export default "__VITE_ASSET__BJcR4NS2__"